import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight, Linkedin, Github } from 'lucide-react';
import { Button } from './Button';

export function Footer() {
  return (
    <footer data-testid="site-footer" className="w-full py-14 md:py-20 px-6">
      <div className="max-w-[1200px] mx-auto">
        {/* Top block: brand + CTA */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end gap-10 mb-14 md:mb-20">
          <Link to="/" className="flex items-center gap-3">
            <img src="/yp-nova-logo.jpg" alt="YP Nova" className="h-20 md:h-24 w-auto object-contain" />
            <span className="sr-only">YP Nova</span>
          </Link>

          <div className="flex flex-col items-start md:items-end gap-4">
            <p className="font-serif text-xl md:text-2xl text-[#0D212C]">
              Your Imagination. Our Creation.
            </p>
            <Button to="/contact" variant="primary" data-testid="footer-cta">
              Book a Discovery Call
            </Button>
          </div>
        </div>

        {/* Link columns */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 pb-10 border-b border-[#051A24]/10">
          <div className="flex flex-col gap-3">
            <span className="text-xs font-mono uppercase tracking-widest text-[#273C46] mb-1">Company</span>
            <Link to="/about" className="text-sm text-[#051A24] hover:opacity-70">About</Link>
            <Link to="/insights" className="text-sm text-[#051A24] hover:opacity-70">Insights</Link>
            <Link to="/contact" className="text-sm text-[#051A24] hover:opacity-70">Contact</Link>
          </div>

          <div className="flex flex-col gap-3">
            <span className="text-xs font-mono uppercase tracking-widest text-[#273C46] mb-1">Offerings</span>
            <Link to="/services" className="text-sm text-[#051A24] hover:opacity-70">Services</Link>
            <Link to="/solutions" className="text-sm text-[#051A24] hover:opacity-70">Solutions</Link>
            <Link to="/case-studies" className="text-sm text-[#051A24] hover:opacity-70">Case Studies</Link>
            <Link to="/industries" className="text-sm text-[#051A24] hover:opacity-70">Industries</Link>
          </div>

          <div className="flex flex-col gap-3">
            <span className="text-xs font-mono uppercase tracking-widest text-[#273C46] mb-1">Legal</span>
            <Link to="/privacy" className="text-sm text-[#051A24] hover:opacity-70">Privacy Policy</Link>
            <Link to="/terms" className="text-sm text-[#051A24] hover:opacity-70">Terms</Link>
          </div>

          <div className="flex flex-col gap-3">
            <span className="text-xs font-mono uppercase tracking-widest text-[#273C46] mb-1">Social</span>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 text-sm text-[#051A24] hover:opacity-70">
              <Linkedin className="w-3.5 h-3.5" /> LinkedIn <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
            <a href="https://github.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 text-sm text-[#051A24] hover:opacity-70">
              <Github className="w-3.5 h-3.5" /> GitHub <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
            <a href="https://x.com" target="_blank" rel="noopener noreferrer" className="flex items-center gap-1 text-sm text-[#051A24] hover:opacity-70">
              x.com <ArrowUpRight className="w-3.5 h-3.5" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export function CopyrightBar() {
  return (
    <div className="w-full py-4 px-6 border-t border-[#051A24]/10">
      <div className="max-w-[1200px] mx-auto flex flex-row justify-between items-center text-sm text-[#051A24]">
        <span>YP Nova · Smart Solutions. Intelligent Future.</span>
        <span>© {new Date().getFullYear()} YP Nova</span>
      </div>
    </div>
  );
}
